import { Form, Paragraph } from "capitalrx-components-2.0";
import { useAlert } from "capitalrx-components-2.0/lib/general";
import { useRequestDiscountCardMutation } from "@/api/getAdvantageCard";
import { CardResponse, CloseModalProp } from "@/types/AdvantageCardRequest";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { WhiteLabelSubmit } from "@/components/WhiteLabelComponents";

import styles from "../styles.module.scss";

const PrintModal = (props: CloseModalProp): JSX.Element => {
  const { onClose } = props;

  const showAlert = useAlert();
  const [requestCard, requestCardResult] = useRequestDiscountCardMutation();

  const group_number = useGroupNumber();

  const handleSubmit = async (): Promise<CardResponse> => {
    await requestCard({
      request_type: 1,
      recipient: "",
      group_number: group_number,
    })
      .unwrap()
      .then((data) => window.open(data.print_url, "_blank"))
      .catch((data) =>
        showAlert({ message: "Failed to print card. Please try again or contact customer support.", type: "error", style: "toast" }),
      );

    onClose();
    return requestCardResult.data;
  };

  return (
    <Form className={styles.ModalForm} onSubmit={handleSubmit}>
      <Paragraph className={styles.ModalFormTitle}>Print Discount Card</Paragraph>
      <Paragraph className={styles.ModalFormSubTitle}>Click below to open a new tab to print the discount card.</Paragraph>
      <WhiteLabelSubmit classNames={styles.ModalFormSubmit} text="Print Card" />
    </Form>
  );
};

export default PrintModal;
